import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const KEY = "cka_visitor_id";

export function getVisitorId() {
  if (typeof window === "undefined") return "";
  const existing = localStorage.getItem(KEY);
  if (existing) return existing;
  const generated = crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
  try {
    localStorage.setItem(KEY, generated);
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("Failed to persist visitor id:", err);
    }
  }
  return generated;
}

/** Fires a page-view for the current route on mount + any location change.
 *  Also scrolls to top on every route change. */
export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    // Auto-scroll to top on route change
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window.scrollTo ? "instant" : "auto" });

    const path = location.pathname + (location.search || "");
    const visitor_id = getVisitorId();
    // Fire & forget — never block the UI on analytics
    api.post("/track/page", {
      path,
      visitor_id,
      referrer: document.referrer || "",
    }).catch(() => {});
  }, [location.pathname, location.search]);

  return null;
}

/** Utility to record a product click from anywhere in the app. */
export function trackProductClick(productId, source = "shop_grid") {
  if (!productId) return;
  api.post(`/track/product/${productId}`, {
    visitor_id: getVisitorId(),
    source,
  }).catch(() => {});
}

/** Utility to record a Studio Gallery tile click. */
export function trackGalleryClick(itemId) {
  if (!itemId) return;
  api.post(`/track/gallery/${itemId}`, {
    visitor_id: getVisitorId(),
  }).catch(() => {});
}
